/** @jsxImportSource @emotion/react */
import { CSSObject } from '@emotion/react';

import { COLORS } from '../../../styles/colors';

const Line = ({ commonStyles }: { commonStyles?: CSSObject }) => (
  <div
    css={{
      minHeight: '0.063rem',
      backgroundColor: COLORS.grey1,
      border: 'none',
      ...commonStyles,
    }}
  />
);

export default Line;
